export const STATE_CHILD_ENTERING = 'STATE_CHILD_ENTERING';
export const STATE_CHILD_VISIBLE = 'STATE_CHILD_VISIBLE';
export const STATE_CHILD_LEAVING = 'STATE_CHILD_LEAVING';
export const STATE_CHILD_EMPTY = 'STATE_CHILD_EMPTY';
